/* actions/actions */
import { action } from "typesafe-actions";
import { TerminalBackground, TerminalBackgroundTypes } from "./types";

export const fetchRequest = (
  id: string | null,
  params?: {},
  callback?: (data, meta) => unknown | null
) => action(TerminalBackgroundTypes.FETCH, { id, params, callback });

export const fetchSuccess = (data) =>
  action(TerminalBackgroundTypes.FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(TerminalBackgroundTypes.FETCH_ERROR, error);

export const saveRequest = (
  data,
  callback?: (err: string | null, data) => unknown
) => action(TerminalBackgroundTypes.SAVE_REQUEST, { data, callback });

export const saveSuccess = (data: TerminalBackground) => action(TerminalBackgroundTypes.SAVE_SUCCESS, data);

export const saveError = (error: string) => action(TerminalBackgroundTypes.SAVE_ERROR, error);

export const deleteRequest = (
  id,
  callback?: (err: string | null, data) => unknown
) => action(TerminalBackgroundTypes.DELETE_REQUEST, { id, callback });
